import { createPortal } from "react-dom";
import React, { useState } from "react";
import { api } from "../../../software/api";
import { toast } from "sonner";
import { X, Check, ArrowRight, Magnet, Trash2 } from "lucide-react";

export const OfficeListPopup = ({ title, items, onClose, onChanged, onOpenClient }) => {
  const [list, setList] = useState(items);
  const [dirty, setDirty] = useState(false);
  const drop = (r) => { setList((l) => l.filter((x) => x.id !== r.id)); setDirty(true); };
  const act = async (r, qs, msg) => { await api("PATCH", `/reminders/${r.id}?${qs}`); toast.success(msg); drop(r); };
  const del = async (r) => {
    if (!window.confirm(`Delete this reminder?\n\n${r.text}`)) return;
    await api("DELETE", `/reminders/${r.id}`); toast.success("Reminder deleted"); drop(r);
  };
  const close = () => (dirty ? onChanged() : onClose());
  return createPortal((
    <div className="fixed inset-0 z-[80] bg-slate-900/50 flex items-center justify-center p-4" onClick={close} data-testid="office-list-popup">
      <div className="w-full max-w-2xl max-h-[85vh] flex flex-col bg-white rounded-2xl shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-5 py-3 border-b border-slate-100">
          <span className="font-display font-black text-slate-900">{title} <span className="text-slate-400 font-bold">· {list.length}</span></span>
          <button onClick={close} data-testid="office-list-close"><X className="h-5 w-5 text-slate-500" /></button>
        </div>
        <div className="overflow-y-auto divide-y divide-slate-100">
          {list.map((r) => (
            <div key={r.id} className="px-5 py-2.5 flex items-start gap-3" data-testid="office-list-item">
              <div className="min-w-0 flex-1">
                <p className="text-[13px] text-slate-800 leading-snug">{r.text}</p>
                <p className="text-[11px] text-slate-500">{r.due_date.split("-").reverse().join("/")}{r.client_name ? ` · ${r.client_name}` : ""}</p>
              </div>
              <button onClick={() => act(r, "on_board=true", "Placed on board")} title="Place on board" data-testid="office-place-on-board-btn" className="rounded-full border border-slate-200 p-1.5 hover:bg-amber-50"><Magnet className="h-4 w-4 text-amber-600" /></button>
              {r.client_id && <button onClick={() => onOpenClient(r.client_id)} title="Open client" data-testid="office-open-client-btn" className="rounded-full border border-slate-200 p-1.5 hover:bg-sky-50"><ArrowRight className="h-4 w-4 text-sky-700" /></button>}
              <button onClick={() => del(r)} title="Delete" data-testid="office-delete-btn" className="rounded-full border border-slate-200 p-1.5 hover:bg-red-50"><Trash2 className="h-4 w-4 text-red-600" /></button>
              {!r.client_id && <button onClick={() => act(r, "done=true", "Done")} title="Mark done" data-testid="office-done-btn" className="rounded-full border border-slate-200 p-1.5 hover:bg-emerald-50"><Check className="h-4 w-4 text-emerald-600" /></button>}
            </div>
          ))}
        </div>
      </div>
    </div>
  ), document.body);
};
